import React, { FC } from 'react';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import { useTranslation } from 'react-i18next';

import './styles.less';
import { onboarding } from '~/routes';
import { LogoWithTextImg, ArrowForwardIcon } from '~/img';
import c from '~/utils/constants';
import { PageNames, useOnboardingState } from '~/hooks/onboarding';
import { useDirection } from '~/hooks';

export const createPath = (pageName: PageNames | undefined): string => {
  if (!pageName) return `/`;
  return `/${onboarding}/${pageName}`;
};

const Sider: FC<RouteComponentProps> = (props) => {
  const { history } = props;
  const { t } = useTranslation('onboarding');
  const dt = (key: string): string => t(`translation:${key}`);
  const [direction] = useDirection();

  const [onboardingState] = useOnboardingState();
  const visiblePages = onboardingState.filter((item) => {
    if (!item.visible) return false;
    return true;
  });

  return (
    <Layout.Sider className="Onboarding-Sider" width={300}>
      <Redirect from={`/${onboarding}`} to={createPath(visiblePages[0].pageName)} />
      <div className="Onboarding-LogoImg">
        <LogoWithTextImg />
      </div>
      <Menu
        onClick={({ key }) => history.push(key.toString())}
        selectedKeys={[history.location.pathname.split('/').slice(0, 3).join('/')]}
        mode="inline"
      >
        {visiblePages.map((item) => {
          return (
            <Menu.Item
              className={`Onboarding-MenuItem Onboarding-MenuItem__${direction}`}
              disabled={item.disabled}
              key={createPath(item.pageName)}
              icon={<ArrowForwardIcon />}
            >
              {t(item.pageName)}
            </Menu.Item>
          );
        })}
      </Menu>
      <div className="Onboarding-PrivacyPolicy">
        <a href={c.privacyPolicyURL} target="__blank">
          {dt('privacyPolicy')}.
        </a>
      </div>
    </Layout.Sider>
  );
};

export default Sider;
